import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	actions: {
		sendContacto : ({commit}, data) => {

			const url = {
				"candidato" : '/api/Alumno/solicitudContacto',
				"empresa" : "/api/Empresa/solicitudContacto"
			}

			return new Promise((resolve, reject) => {
				axios.post(url[data.type],data).then( result => {
					if(result.data.status == 0){	
						resolve(true);
						commit('setError',602)
					}else{
						commit('setError',result.data.status)
					}
				}).catch(error => {
					reject(false);
				});  
			});	
		},
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js